module.exports = __webpack_public_path__ + "static/media/bookshelf.c0d20017.png";